export default __webpack_public_path__ + "static/aboutus-image1-5621d60a1b33660694f2d7748b9af68b.jpg";